<div class="inner-container ion-text-center">
    <div class="centered-content">
      <span class="no-data">
        <ion-text large class="no-data">
          <ion-icon name="cloud-offline"></ion-icon>
          <br><br>
          <strong>
            {{ 'http-error-service.Información'  | translate }}
          </strong>
          <!-- {{ errorMsg }} -->
          <br>
          <ion-text small color="medium">{{ 'http-error-service.Error al conectar con el servidor, intente nuevamente'  | translate }}</ion-text>
        </ion-text>
        <br><br>
        <ion-text class="ion-text-center" color="primary" (click)="retry.emit()">
          {{ 'http-error-service.Reintentar'  | translate }}
        </ion-text>
      </span>
    </div>
  </div>